import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit, FaFileExport, FaTrash, FaUserShield } from "react-icons/fa";

import Android12Switch from "../../components/common/AndroidSwitch";

import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import PaginationComponent from "../../components/common/PaginationModal";

import NoResultFoundModel from "../../components/common/NoDataFound";
import { GetCustomerIndustryList } from "../../services/CustomerIndustry/CustomerIndustryApi";
import { GetCustomerReport } from "../../services/ReportApi/ReportApi";
import * as XLSX from "xlsx"; // ✅ Correct

const tabs = [{ id: 1, label: "Customer Report" }];

function ReportList() {
  const navigate = useNavigate();
  const RoleTypeModuleName = "Predefined";

  const [activeTab, setActiveTab] = useState(() => {
    const storedTab = Number(localStorage.getItem("selectedTab"));
    const storedPath = localStorage.getItem("CurrentPath");
    return storedPath === "/setting" && storedTab ? storedTab : 1;
  });
  const [errorMessage, setErrorMessage] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);
  //user role Type variables
  const [CustomerReportSearch, setCustomerIndustrySearch] = useState("");
  const [CustomerReportList, setCustomerIndustryList] = useState([]);
  const [CustomerReportListCount, setCustomerReportListCount] = useState(0);
  const [CustomerReportListCurrentPage, setCustomerReportListCurrentPage] =
    useState(1);

  const [modelRequestData, setModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
    remark: null,
  });

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    if (tab === 1) {
      GetCustomerReportData(1);
    }
  };
  //initial UseEffect
  useEffect(() => {
    if (activeTab === 1) {
      GetCustomerReportData(1);
    }
  }, []);

  useEffect(() => {
    if (isAddUpdateDone) {
      if (activeTab === 1) {
        setCustomerIndustrySearch("");
        GetCustomerReportData(CustomerReportListCurrentPage, null);
      }
      setIsAddUpdateDone(false);
    }
  }, [isAddUpdateDone]);

  //User Role Type Search
  const handleSearchFunction = (searchValue) => {
    if (activeTab === 1) {
      setCustomerIndustrySearch(searchValue);
      GetCustomerReportData(1, searchValue);
    }
  };

  //tab Save UseEffect
  useEffect(() => {
    localStorage.setItem("selectedTab", activeTab);
    localStorage.setItem("CurrentPath", "/report");
  }, [activeTab]);

  //User Role List Api
  const GetCustomerReportData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetCustomerReport({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? CustomerReportSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setCustomerReportListCount(response.totalCount);
        setCustomerIndustryList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const HandlePageChange = async (pageNumber) => {
    if (activeTab === 1) {
      setCustomerReportListCurrentPage(pageNumber);
      await GetCustomerReportData(pageNumber); // Call your function with the selected page number
    }
  };

  const handleExportCustomerReport = () => {
    const wb = XLSX.utils.book_new();
    const titleText = "Customer Report";
    const headers = [
      "Customer Code",
      "Company Name",
      "Account Manager",
      "Customer Industry Name",
      "Registered Date",
      "Subscription Name",
      "Purchase Date",
      "Renew Date",
      "Total Users",
      "Total Clients",
    ];

    // Map the customer report data
    const data = CustomerReportList.map((row) => [
      row.customerCode || "-",
      row.companyName || "-",
      row.accountManager || "-",
      row.customerIndustryName || "-",
      row.createdOnDate
        ? new Date(row.createdOnDate).toLocaleDateString()
        : "-",
      row.subscriptionPackageName || "-",
      row.subscriptionPurchaseDate
        ? new Date(row.subscriptionPurchaseDate).toLocaleDateString()
        : "-",
      row.subscriptionNextRenewDate
        ? new Date(row.subscriptionNextRenewDate).toLocaleDateString()
        : "-",
      row.totalUsers || "-",
      row.totalClients || "-",
    ]);

    const ws_data = [[titleText], [], headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];
    ws["A1"].s = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center", vertical: "center" },
    };

    for (let col = 0; col < headers.length; col++) {
      let cellAddress = XLSX.utils.encode_cell({ c: col, r: 2 });
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "D9D9D9" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    }

    XLSX.utils.book_append_sheet(wb, ws, "Customer Report");
    XLSX.writeFile(wb, "Customer_Report.xlsx");
  };

  return (
    <>
      <div className="bg-gray-50 mx-auto mb-10">
        <div className="bg-white shadow-lg rounded-lg px-6">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 15px",
            }}
            className="p-4 overflow-x-auto"
          >
            <>
              <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`px-4 py-2 whitespace-nowrap border-b-2 ${
                      activeTab === tab.id
                        ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                        : "border-transparent text-gray-900"
                    }`}
                    onClick={() => {
                      handleChangeTab(tab.id);
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </>
          </div>

          {/* Tab Content */}
          {/* User Role */}
          {activeTab === 1 && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="flex flex-wrap items-center gap-2 md:gap-4 ml-auto w-full md:w-auto justify-end">
                      {/* Export Button */}
                      <button
                        onClick={handleExportCustomerReport}
                        className="flex items-center text-[#135EA0]  text-12"
                      >
                        <FaFileExport className="mr-1" />
                        Export
                      </button>

                      {/* Filter Button */}
                      {/* <button className="flex items-center text-[#135EA0]  text-12">
                               <FaFilter className="mr-1" />
                               Filter
                             </button> */}

                      {/* Search Bar */}
                      <div className="relative flex items-center w-full md:w-64">
                        <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700 mb-5"></span>
                        <input
                          type="text"
                          className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full mb-4"
                          placeholder="Search..."
                          value={CustomerReportSearch}
                          onChange={(e) => {
                            handleSearchFunction(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    {/* <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Customer Report
                        </button>
                      </div>
                    </div> */}

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper border border-gray-200">
                      <div className="flex-1 overflow-y-auto">
                        <table className="w-full border-collapse border border-gray-300 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Code
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Company Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Account Manager
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Registerd Date
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Subscription Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Purchase Date
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Renew Date
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Total Users
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Total Clients
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {CustomerReportList?.map((role, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left p-1">
                                  {role.customerCode}
                                </td>
                                <td className="whitespace-nowrap text-left p-1">
                                  {role.companyName}
                                </td>

                                <td className="whitespace-nowrap text-left p-1">
                                  {role.accountManager}
                                </td>

                                <td className="whitespace-nowrap text-left p-1">
                                  {role.customerIndustryName}
                                </td>

                                <td className="p-1 text-center">
                                  {role.createdOnDate
                                    ? new Date(
                                        role.createdOnDate
                                      ).toLocaleDateString()
                                    : "-"}
                                </td>

                                <td className="whitespace-nowrap text-left p-1">
                                  {role.subscriptionPackageName}
                                </td>

                                <td className="p-1 text-center">
                                  {role.subscriptionPurchaseDate
                                    ? new Date(
                                        role.subscriptionPurchaseDate
                                      ).toLocaleDateString()
                                    : "-"}
                                </td>

                                <td className="p-1 text-center">
                                  {role.subscriptionNextRenewDate
                                    ? new Date(
                                        role.subscriptionNextRenewDate
                                      ).toLocaleDateString()
                                    : "-"}
                                </td>
                                <td className="whitespace-nowrap text-center p-1">
                                  {role.totalUsers}
                                </td>
                                <td className="whitespace-nowrap text-center p-1">
                                  {role.totalClients}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {CustomerReportListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={CustomerReportListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {CustomerReportListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            CustomerReportListCount / pageSize
                          )}
                          currentPage={CustomerReportListCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ReportList;
